import useUserAccount from "@/account/use-user-account";

const { waitForUserAccount } = useUserAccount();

// const SCEChatOptions = {
//     opt: {
//         widget_height: 340,
//         widget_width: 300,
//         popup_height: 340,
//         popup_width: 300
//     }
// };

export const initChat = () => {
    const po = document.createElement("script");
    po.type = "text/javascript";
    po.async = true;

    const referrer = document.referrer ? encodeURIComponent(document.referrer.substr(document.referrer.indexOf("://") + 1)) : "";
    const location = document.location ? encodeURIComponent(window.location.href.substring(window.location.protocol.length)) : "";

    if (window.environment && window.environment.env === "Production") {
        po.src =
            "//chat-new.sazka.cz/index.php/cse/chat/getstatus/(click)/internal/(position)/api/(ma)/br/(top)/350/(units)/pixels/(department)/3/(leaveamessage)/true/(theme)/3/(survey)/3?r=" +
            referrer +
            "&l=" +
            location;
    } else {
        po.src =
            "//chat-new.uat.sazka.cz/index.php/cse/chat/getstatus/(click)/internal/(position)/api/(ma)/br/(top)/350/(units)/pixels/(department)/3/(leaveamessage)/true/(theme)/3/(survey)/3?r=" +
            referrer +
            "&l=" +
            location;
    }

    document.body.appendChild(po);
};

export const registerChatToWindow = () => {
    (window as any).showChat = async () => {
        const userData = await waitForUserAccount();
        let user = null;
        user = {
            Username: userData.value?.phone,
            creativeCode: "default",
            campaignCode: "default",
            ProactiveChat: "false",
        };

        if (window.sce_instance) {
            window.sce_instance.showChat(user);
        }
    };
};
